export default function (prefix) {
  return {
    visitorInfo: prefix + '/webim/visitor/findOrCreate', // 访客信息
    visitorHistoryMsg: prefix + '/webim/visitor/historyMsg', // 历史聊天记录
    msgInService: prefix + '/webim/visitor/getCacheMessage', // 实时聊天记录
    revokeMessage: prefix + '/webim/visitor/revokeMessage', // 撤回
    upload: prefix + '/visitorSide/im/chatMessage/upload', // 上传文件
    getSkill: prefix + '/visitorSide/skill/getSkill', // 获得技能组
    queryGroupByChannel: prefix + '/visitorSide/csChannel/queryGroupByChannel', // 获得技能组通过
    queueNum: prefix + '/webim/visitor/queueNum', // 获得排队数量
    switchLabor: prefix + '/webim/visitor/switchLabor', // 转人工
    finish: prefix + '/webim/visitor/finish', // 结束会话
    resetUnReadCount: prefix + '/webim/visitor/resetUnReadCount', // 清除未读条数
    queryOnlineReply: prefix + '/visitorSide/leaveMessage/queryReply', // 查询在线回复
    findMessages: prefix + '/offlinemessage/visitor/findMessages',
    uploadCancel: prefix + '/visitorSide/im/chatMessage/uploadCancel',
    setHasReadvis: prefix + '/visitorSide/leaveMessage/setHasRead',
    getout: prefix + '/webim/visitor/getout',  // 退出排队
    getReferenceMessageDetail : prefix + '/webim/refMessage/getDetail',  // 消息引用--查询belong（设置头像）
  }
}
